import * as Yup from 'yup'

const phoneRegExp = /^(((\+?64\s*[-.]?[3-9]|\(?0[3-9]\)?)\s*[-.]?\d{3}\s*[-.]?\d{4})|((\+?64\s*[-.(]?2\d{1}[-.)]?|\(?02\d{1}\)?)\s*[-.]?\d{3}\s*[-.]?\d{3,5})|((\+?64\s*[-.]?[-.(]?800[-.)]?|[-.(]?0800[-.)]?)\s*[-.]?\d{3}\s*[-.]?(\d{2}|\d{5})))$/

const getYupValidationSchema = values => {
    return Yup.object().shape({
        branches: Yup.array()
            .required('Branch is required!'),
        departments: Yup.array()
            .required('Department is required!'),
        colorLeave: Yup.string()
            .trim()
            .required('Color is required!'),
        colorNormal: Yup.string()
            .trim()
            .required('Color is required!'),
    })
}

export default function validate(values) {
    return values => {
        const validationSchema = getYupValidationSchema(values)

        try {
            validationSchema.validateSync(values, { abortEarly: false })

            return {}
        } catch (error) {
            return getErrorsFromValidationError(error)
        }
    }
}

function getErrorsFromValidationError(validationError) {
    const FIRST_ERROR = 0
    return validationError.inner.reduce((errors, error) => {
        let path = error.path
        return {
            ...errors,
            [path]: error.errors[FIRST_ERROR],
        }
    }, {})
}
